import { IllegalOperationException } from '../exceptions/illegal-operation-exception.js';

/**
 * Contains math operations that work exactly like the ones in dart.
 */
export class DartMath {
  static round(n: number): number {
    if(n === Infinity) {
      throw new IllegalOperationException('Infinity can not be rounded.');
    }

    return Math.round(Math.abs(n)) * Math.sign(n);
  }

  static toInt(n: number): number {
    if(n === Infinity) {
      throw new IllegalOperationException('Infinity can not be converted to int.');
    }

    return Math.floor(Math.abs(n)) * Math.sign(n);
  }

  static lerp(v0: number, v1: number, t: number): number {
    return (1.0 - t) * v0 + t * v1;
  }

  static clamp(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
  }
}
